import { z } from "zod";

export const Sizes: Record<string, [w: number, h: number]> = {
  "2x1": [2, 1],
  "2x2": [2, 2],
  "3x1": [3, 1],
  "3x2": [3, 2],
  "3x3": [3, 3],
};

export const CardStyles = {
  default: {
    name: "Default",
  },
  defaultBlur: {
    name: "Default Blurred",
  },
  light: {
    name: "Light",
  },
  lightBlur: {
    name: "Light Blurred",
  },
  dark: {
    name: "Dark",
  },
  darkBlur: {
    name: "Dark Blurred",
  },
  colorful: {
    name: "Colorful",
  },
  colorfulBlur: {
    name: "Colorful Blurred",
  },
  modern: {
    name: "Modern",
  },
  modernBlur: {
    name: "Modern Blurred",
  },
} as const;

export const cardSettingsFormSchema = z.object({
  title: z.string().optional(),
  deepKey: z.string().optional(),
  valueTransformation: z.string().optional(),
  objectKey: z.string().optional(),
  fallback: z
    .object({
      value: z.string().optional(),
      showError: z.boolean().default(true),
    })
    .optional(),
  display: z
    .object({
      prefix: z.string().optional(),
      suffix: z.string().optional(),
      showIcon: z.boolean().default(false),
      icon: z.string().optional(),
      size: z.enum(["small", "medium", "large"]).default("medium"),
      style: z.string().optional(),
    })
    .optional(),
});
